import React, { useRef, useState } from 'react';
import { Slider, InputNumber, Row, Col, Input, Typography, Switch } from 'antd';
import { Button } from '@alifd/next';
import styles from './templateSize.module.scss';

const BroadcastTemplateFrom = (props) => {
  const {
    title,
    setTitle,
    uploadPath,
    setUploadPath,
    uploadData,
    setUploadData,
    full,
    setFull,
  } = props;
  const uploadRef = useRef(null);

  return (
    <Row>
      <Col span={4}>
        <font style={{ color: 'red' }}>*</font>公播名稱：
      </Col>
      <Col span={16}>
        <Input
          placeholder="請輸入名稱"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
      </Col>

      <Col span={4} />
      <Col span={4} style={{ marginTop: 10 }}>
        <font style={{ color: '#FAFAFA' }}>*</font>是否滿版：
      </Col>
      <Col span={16} style={{ textAlign: 'left', marginTop: 10 }}>
        <Switch
          checked={full}
          onChange={(value) => setFull(value)}
          checkedChildren="是"
          unCheckedChildren="否"
        />
      </Col>
      <Col span={4} />
      <Col span={4} style={{ marginTop: 10 }}>
        <font style={{ color: '#FAFAFA' }}>*</font>背景音樂：
      </Col>
      <Col span={16} style={{ textAlign: 'left', marginTop: 10 }}>
        <Button
          onClick={() => {
            uploadRef.current.click();
          }}
        >
          上傳附件
        </Button>
        {uploadPath && (
          <>
            <Typography.Text type="secondary">
              {uploadData.name}
            </Typography.Text>
            <Button
              text
              onClick={() => {
                setUploadData(null);
                setUploadPath('');
              }}
              style={{ opacity: 0.45 }}
            >
              清除
            </Button>
          </>
        )}
        <input
          ref={uploadRef}
          type="file"
          id="upload"
          value={uploadPath}
          style={{ display: 'none' }}
          onChange={(e) => {
            const file = e.target.files[0];
            setUploadData(file);
            setUploadPath(e.target.value);
          }}
        />
      </Col>
      <Col span={4} />
    </Row>
  );
};

const BroadcastTemplateSize = (props) => {
  const {
    inputValueOne,
    setInputValueOne,
    inputValueTwo,
    setInputValueTwo,
    inputValueTop,
    setInputValueTop,
    inputValueBottom,
    setInputValueBottom,
  } = props;

  if (props.template === 'one') {
    return (
      <div className={styles.container}>
        <div className={styles.templateOne}>區塊一</div>
        <div className={styles.templateSetting}>
          <BroadcastTemplateFrom {...props} />
        </div>
      </div>
    );
  } else if (props.template === 'two') {
    return (
      <div className={styles.container}>
        <div className={styles.templateTop}>
          <div
            className={styles.templateTwo}
            style={{ width: `${inputValueOne}%` }}
          >
            區塊一
          </div>
          <div
            className={styles.templateTwo}
            style={{ width: `${inputValueTwo}%` }}
          >
            區塊二
          </div>
        </div>
        <div className={styles.templateSetting}>
          <BroadcastTemplateFrom {...props} />
          <Row>
            <Col span={4}>區塊一(%)：</Col>
            <Col span={16}>
              <Slider
                min={10}
                max={90}
                value={inputValueOne}
                onChange={(value) => {
                  setInputValueOne(value);
                  setInputValueTwo(100 - value);
                }}
              />
            </Col>
            <Col span={4}>
              <InputNumber
                min={10}
                max={90}
                style={{ margin: '0 16px' }}
                value={inputValueOne}
                onChange={(value) => {
                  setInputValueOne(value);
                  setInputValueTwo(100 - value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col span={4}>區塊二(%)：</Col>
            <Col span={16}>
              <Slider
                min={10}
                max={90}
                value={inputValueTwo}
                onChange={(value) => {
                  setInputValueTwo(value);
                  setInputValueOne(100 - value);
                }}
              />
            </Col>
            <Col span={4}>
              <InputNumber
                min={10}
                max={90}
                style={{ margin: '0 16px' }}
                value={inputValueTwo}
                onChange={(value) => {
                  setInputValueTwo(value);
                  setInputValueOne(100 - value);
                }}
              />
            </Col>
          </Row>
        </div>
      </div>
    );
  } else if (props.template === 'three') {
    return (
      <div className={styles.container}>
        <div className={styles.templateContent}>
          <div
            className={styles.templateTop}
            style={{ height: `${inputValueTop}%` }}
          >
            區塊一
          </div>
          <div
            className={styles.templateBottom}
            style={{ height: `${inputValueBottom}%` }}
          >
            區塊二
          </div>
        </div>
        <div className={styles.templateSetting}>
          <BroadcastTemplateFrom {...props} />
          <Row>
            <Col span={4}>區塊一(%)：</Col>
            <Col span={16}>
              <Slider
                min={10}
                max={90}
                value={inputValueTop}
                onChange={(value) => {
                  setInputValueTop(value);
                  setInputValueBottom(100 - value);
                }}
              />
            </Col>
            <Col span={4}>
              <InputNumber
                min={10}
                max={90}
                style={{ margin: '0 16px' }}
                value={inputValueTop}
                onChange={(value) => {
                  setInputValueTop(value);
                  setInputValueBottom(100 - value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col span={4}>區塊二(%)：</Col>
            <Col span={16}>
              <Slider
                min={10}
                max={90}
                value={inputValueBottom}
                onChange={(value) => {
                  setInputValueBottom(value);
                  setInputValueTop(100 - value);
                }}
              />
            </Col>
            <Col span={4}>
              <InputNumber
                min={10}
                max={90}
                style={{ margin: '0 16px' }}
                value={inputValueBottom}
                onChange={(value) => {
                  setInputValueBottom(value);
                  setInputValueTop(100 - value);
                }}
              />
            </Col>
          </Row>
        </div>
      </div>
    );
  } else if (props.template === 'four') {
    return (
      <div className={styles.container}>
        <div className={styles.templateContent}>
          <div
            className={styles.templateTop}
            style={{ height: `${inputValueTop}%` }}
          >
            <div
              className={styles.templateFour}
              style={{ width: `${inputValueOne}%` }}
            >
              區塊一
            </div>
            <div
              className={styles.templateFour}
              style={{ width: `${inputValueTwo}%` }}
            >
              區塊二
            </div>
          </div>
          <div
            className={styles.templateBottom}
            style={{ height: `${inputValueBottom}%` }}
          >
            區塊三
          </div>
        </div>
        <div className={styles.templateSetting}>
          <BroadcastTemplateFrom {...props} />
          <Row>
            <Col span={4}>區塊一(%)：</Col>
            <Col span={16}>
              <Slider
                min={10}
                max={90}
                value={inputValueOne}
                onChange={(value) => {
                  setInputValueOne(value);
                  setInputValueTwo(100 - value);
                }}
              />
            </Col>
            <Col span={4}>
              <InputNumber
                min={10}
                max={90}
                style={{ margin: '0 16px' }}
                value={inputValueOne}
                onChange={(value) => {
                  setInputValueOne(value);
                  setInputValueTwo(100 - value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col span={4}>區塊二(%)：</Col>
            <Col span={16}>
              <Slider
                min={10}
                max={90}
                value={inputValueTwo}
                onChange={(value) => {
                  setInputValueTwo(value);
                  setInputValueOne(100 - value);
                }}
              />
            </Col>
            <Col span={4}>
              <InputNumber
                min={10}
                max={90}
                style={{ margin: '0 16px' }}
                value={inputValueTwo}
                onChange={(value) => {
                  setInputValueTwo(value);
                  setInputValueOne(100 - value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col span={4}>區塊三(%)：</Col>
            <Col span={16}>
              <Slider
                min={10}
                max={90}
                value={inputValueBottom}
                onChange={(value) => {
                  setInputValueBottom(value);
                  setInputValueTop(100 - value);
                }}
              />
            </Col>
            <Col span={4}>
              <InputNumber
                min={10}
                max={90}
                style={{ margin: '0 16px' }}
                value={inputValueBottom}
                onChange={(value) => {
                  setInputValueBottom(value);
                  setInputValueTop(100 - value);
                }}
              />
            </Col>
          </Row>
        </div>
      </div>
    );
  }
};

export default BroadcastTemplateSize;
